export const FSA_MONITORING_REPORT_THRESHOLD = 10;